import React, { useEffect } from 'react';
import Highcharts from 'highcharts/highstock';
import { useIntl } from 'react-intl';


function ReportChart(props) {
	const intl = useIntl();
	function init() {
		const currentData = Array.isArray(props.data?.current) ? props.data.current : [];
		const lastData = Array.isArray(props.data?.last) ? props.data.last : [];

		Highcharts.chart(props.reportID, {
			chart: {
				isSynced: true,
				marginLeft: 40, // Keep all charts left aligned
				spacingTop: 20,
				spacingBottom: 20
			},
			title: {
				text: null,
				// align: 'left',
				// margin: 0,
				// x: 30
			},
			plotOptions: {
				column: {
					dataLabels: {
						rotation: currentData.length > 5 ? -90 : 0,
						enabled: true,
						allowOverlap: true,
						y: currentData.length > 5 ? -20 : 0,
						style: {
							color: 'black',
							fontSize: '13px',
							fontWeight: 'bold',
							textOutline: null
						}
					}
				}
			},
			credits: {
				enabled: false
			},
			legend: {
				verticalAlign: 'top',
				enabled: true
			},
			xAxis: {
				type: 'category',
				categories: currentData.map(i => i.name),
				crosshair: true,
				// Uncomment to sync scrolling accross charts
				// events: {
				// 	setExtremes: props.sync
				// },
				min: 0,
				max: currentData.length < 20 ? currentData.length - 1 : 20,
				scrollbar: {
					enabled: currentData.length >= 20,
					barBackgroundColor: '#D2DBE8',
					barBorderRadius: 7,
					barBorderWidth: 0,
					buttonBackgroundColor: '#D2DBE8',
					buttonBorderWidth: 0,
					buttonBorderRadius: 7,
					trackBackgroundColor: 'none',
					trackBorderWidth: 1,
					trackBorderRadius: 8,
					trackBorderColor: '#CCC'
				},
			},
			tooltip: {
				// positioner: function () {
				// 	return {
				// 		// right aligned
				// 		x: this.chart.chartWidth - this.label.width,
				// 		y: 10 // align to title
				// 	};
				// },
				// borderWidth: 0,
				// backgroundColor: 'none',
				// pointFormat: '{point.y}',
				// headerFormat: '',
				// shadow: false,
				// style: {
				// 	fontSize: '18px'
				// },
				shared: true
				// valueDecimals: dataset.valueDecimals
			},
			series: [{
				data: lastData,
				name: intl.formatMessage({ id: "app.report.weatherReport.lastYear", defaultMessage: 'LAST YEAR' }),
				type: 'column',
				color: props.colors[0],
				fillOpacity: 0.3,
				// tooltip: {
				// 	valueSuffix: ' ' + dataset.unit
				// }
			}, {
				data: currentData,
				name: intl.formatMessage({ id: "app.report.weatherReport.current", defaultMessage: 'CURRENT' }),
				type: 'column',
				color: props.colors[1],
				fillOpacity: 0.3,
				// tooltip: {
				// 	valueSuffix: ' ' + dataset.unit
				// }
			}]
		});
	}

	useEffect(() => {
		if (props.reportID)
			init();
	}, [props.data, props.reportID]);

	return (
		<div style={{ width: '100%', height: '450px', marginTop: '25px' }}>
			<span className='uppercase' style={{ fontSize: '1.4em', }}>{props.title}</span>
			<div id={props.reportID}>
			</div>
		</div>);
}


export default ReportChart;
